import React, {useState} from 'react';
import {connect} from 'react-redux';
import {logClicksActions} from '../../store/actions/logClicksAction';
import LogConversionDialog from './LogConversionDialog';

function LogClicksAddConversion({history, location, match, rerender}) {
    const [open, setOpen] = useState(true);
    const handleClose = () => {
        setOpen(false);
        history.push({pathname: '/log/clicks', state: {from: location}});
    };
    return <LogConversionDialog open={open} mode="add" clickId={match?.params?.id} onClose={handleClose} onSaved={() => {rerender(); handleClose();}}/>;
}

export default connect(null, {rerender: logClicksActions.rerender})(LogClicksAddConversion);
